<template>
    <div>
        <!-- 地板首页第一屏 -->
        <div class="floorFirst">
            <img class="img_cover" :src="kv_image" alt="" />
        </div>
    </div>
</template>

<script>
    export default {
        name: "",
        props: {},
        data() {
            return {
                kv_image: "",
            };
        },

        mounted() {
            var index = Number(this.$route.query.id);
            var indata = Number(this.$route.query.in);
            // if (this.$store.state.floorData.length === 0) {
            //   // setTimeout(() => {
            //     var obj = this.$store.state.floorData[index];
            //     this.kv_image = obj.kv_image;
            //   // }, 500);
            // }else{
            if (index == 0) {
                var obj = this.$store.state.floorData[index] || JSON.parse(localStorage.getItem('floorData'))[index];
                this.kv_image = obj.children[indata].kv_image;
            } else {
                var obj = this.$store.state.floorData[index] || JSON.parse(localStorage.getItem('floorData'))[index];
                this.kv_image = obj.kv_image;
            }
            // }
        },
        computed: {
            floorData() {
                return this.$store.state.floorData;
            },
        },
        watch: {
            floorData(val) {
                console.log(val)
            }
        }
    };
</script>

<style scoped lang='scss'>
    .floorFirst {
        width: 100%;
        height: 100vh;
        background: #1a1a1a;
    }
</style>
